import {request} from "services/api/util";

class BrandService {
  async getListBrands(param) {
    const config = {
      method: "get",
      url: `admin/brand`,
      params: param,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    };

    return request(config);
  }
  async getDetailBrand(brandCode, params) {
    const config = {
      method: "get",
      url: `admin/brand/${brandCode}`,
      params: params,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };

    return request(config);
  }
  async createOrUpdateBrand(body, id, update) {
    let config;
    if (update) {
      config = {
        method: "put",
        url: `admin/brand/${id}`,
        data: body,
        headers: {
          "content-type": "	application/json;charset=UTF-8",
        },
      };
    } else {
      config = {
        method: "post",
        url: `admin/brand`,
        data: body,
        headers: {
          "content-type": "	application/json;charset=UTF-8",
        },
      };
    }

    return request(config);
  }
}

export default new BrandService();
